import { STRINGS } from "../constants/strings";
import { SecondaryButton, TextButton } from "./buttons";

interface BenefitProps {
  icon: string;
  title: string;
  body: string;
}

function Benefit({ icon, title, body }: BenefitProps) {
  return (
    <div class="tl-promoter-benefit">
      <div class="tl-promoter-benefit__icon">
        <span class="material-icons" aria-hidden="true">
          {icon}
        </span>
      </div>
      <div>
        <div class="tl-promoter-benefit__title">{title}</div>
        <div class="tl-promoter-benefit__body">{body}</div>
      </div>
    </div>
  );
}

interface Props {
  companyName: string;
  onCta: () => void;
  onLater?: () => void;
}

export function PromoterInviteCard({ companyName, onCta, onLater }: Props) {
  return (
    <section class="tl-promoter-section">
      <div class="tl-promoter-kicker">{STRINGS.promoterKicker}</div>
      <h2 class="tl-screen-title">{STRINGS.promoterTitle}</h2>
      <p class="tl-screen-body" style="margin: 0 auto;">
        {STRINGS.promoterBody(companyName)}
      </p>
      <div class="tl-promoter-card">
        <Benefit
          icon="share"
          title={STRINGS.promoterBenefitLinkTitle}
          body={STRINGS.promoterBenefitLinkText}
        />
        <Benefit
          icon="payments"
          title={STRINGS.promoterBenefitPayTitle}
          body={STRINGS.promoterBenefitPayText}
        />
        <Benefit
          icon="insights"
          title={STRINGS.promoterBenefitTransTitle}
          body={STRINGS.promoterBenefitTransText}
        />
        <div class="tl-promoter-footer">
          <span class="tl-promoter-disclaimer">
            {STRINGS.promoterDisclaimer}
          </span>
          <div style="display: flex; gap: 8px; align-items: center;">
            {onLater && (
              <TextButton text={STRINGS.promoterLater} onClick={onLater} />
            )}
            <SecondaryButton
              text={STRINGS.promoterCta}
              icon="campaign"
              onClick={onCta}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
